(function () {
  'use strict';
  document.addEventListener('DOMContentLoaded', function () {
    var wrapper = document.getElementById('reviews');
    if (!wrapper) return;
    var initialCount = parseInt(wrapper.getAttribute('data-initial-visible-count'), 10);
    if (isNaN(initialCount) || initialCount <= 0) return;
    var cards = wrapper.querySelectorAll('.rev-card');
    var loadMoreBtn = wrapper.querySelector('[data-rev-load-more]');
    if (cards.length <= initialCount) {
      if (loadMoreBtn) loadMoreBtn.parentElement.style.display = 'none';
      return;
    }
    cards.forEach(function (card, index) {
      if (index >= initialCount) {
        card.setAttribute('data-rev-hidden', 'true');
        card.style.display = 'none';
      }
    });
    if (loadMoreBtn) {
      loadMoreBtn.addEventListener('click', function () {
        cards.forEach(function (card) {
          if (card.getAttribute('data-rev-hidden') === 'true') {
            card.style.display = '';
            card.removeAttribute('data-rev-hidden');
          }
        });
        loadMoreBtn.parentElement.style.display = 'none';
      });
    }
  });
})();
